const ORG_SCOPED_DETAIL_ROUTE_PATTERNS = [/^\/jobs\/[^/]+/];

export function getOrgSwitchRedirectDestination(asPath: string): string | null {
  return ORG_SCOPED_DETAIL_ROUTE_PATTERNS.some((re) => re.test(asPath))
    ? "/jobs"
    : null;
}
